import Vue from 'vue'
import supplyConfigTransformer from '@/transformers/catalog/warehouse/supplyConfig'

/**
 * @author jorge nuñez lópez <>
 *
 * Delete supply configuration
 * @param Id config identification 
 * @return {object}
 */

export default (id) => {
  return Vue.$http.delete(`iwarehouse/supply-retrieve-update-delete/${id}/`)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/deleteSupplyConfig.js